import { render, staticRenderFns } from "./MoleculeEditionProductArtificialIntelligenceSubMenu.vue?vue&type=template&id=3f7b44bc&"
import script from "./MoleculeEditionProductArtificialIntelligenceSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductArtificialIntelligenceSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports